var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.513672,
    y: 0.59668,
    width: 34.7463,
    height: 34.7463,
    rx: 2.89552,
    fill: "#FF6900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5681 18.625C20.5354 18.6585 20.4118 18.8022 20.2967 18.9203C19.622 19.6633 17.8618 20.8794 16.9406 21.2506C16.8007 21.3103 16.4469 21.4365 16.2579 21.4446C16.0768 21.4446 15.9042 21.4029 15.7395 21.3184C15.5341 21.2002 15.3694 21.0143 15.2791 20.7949C15.221 20.6426 15.1308 20.1868 15.1308 20.1787C15.0405 19.6801 14.9908 18.8699 14.9908 17.9746C14.9908 17.1216 15.0405 16.3444 15.1144 15.8383C15.1229 15.8302 15.2131 15.2638 15.3118 15.0698C15.4929 14.7154 15.8467 14.4954 16.2252 14.4954H16.2579C16.5045 14.504 17.0229 14.7241 17.0229 14.7322C17.8945 15.104 19.6141 16.2605 20.3052 17.0289C20.3052 17.0289 20.4998 17.2264 20.5844 17.3498C20.7164 17.527 20.7819 17.7465 20.7819 17.9659C20.7819 18.2109 20.708 18.4391 20.5681 18.625",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/right_icon.8adc51feb4894b23c302ef3e506a9b42.svg";
export { ForwardRef as ReactComponent };